import { css } from 'styled-components';
import { spaces } from '@engage/styles';
import { fontWeights } from '../shared';

export const number64 = css`
  font-size: ${spaces.xxxHuge}px;
  line-height: ${spaces.xxxHuge}px;
  font-weight: ${fontWeights.bold};
  letter-spacing: 0;
`;

export const number40 = css`
  font-size: ${spaces.huge}px;
  line-height: ${spaces.huge}px;
  font-weight: ${fontWeights.bold};
  letter-spacing: 0;
`;

export const number32 = css`
  font-size: ${spaces.xxxLarge}px;
  line-height: ${spaces.xxxLarge}px;
  font-weight: ${fontWeights.bold};
  letter-spacing: 0;
`;

export const number24 = css`
  font-size: ${spaces.xLarge}px;
  line-height: ${spaces.xLarge}px;
  font-weight: ${fontWeights.xxxBold};
  letter-spacing: 0;
`;

export const number20 = css`
  font-size: ${spaces.large}px;
  line-height: ${spaces.large}px;
  font-weight: ${fontWeights.xxBold};
  letter-spacing: 0;
`;

export const number16 = css`
  font-size: ${spaces.medium}px;
  line-height: ${spaces.medium}px;
  font-weight: 700;
  letter-spacing: 0;
`;

export const number14 = css`
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  letter-spacing: 0;
`;
